import React from "react";
import moment from "moment/moment";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import NotificationPing from "../../../ui-components/NotificationPing";
import Badge from "../../../ui-components/Badge";

export const getColumns = (
  intl,
  countryCode,
  lkpStatus,
  countryApiRequest,
  push,
  onAction,
  showLinks
) => [
  {
    title: "",
    filtering: false,
    render: (rowData) => (
      <>
        <div className="flex flex-row gap-5">
          {(showLinks || !rowData.id) && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                rowData.status !== "reported_f"
                  ? `/${countryCode}/worksites/${rowData["cod_worksite_id"]}/reference/${rowData["id"]}`
                  : `/${countryCode}/worksites/${rowData["cod_worksite_id"]}`
              }
              onClick={() => {
                if (rowData.isNew || rowData.hasNotification)
                  onAction(rowData.id, rowData.cod_worksite_id);
              }}
            >
              <ArrowTopRightOnSquareIcon
                className={`w-6 h-6 text-kerakoll-400 cursor-pointer`}
              />
            </a>
          )}
          {rowData.status === "closed_f" && (
            <ArrowDownTrayIcon
              className="w-6 h-6 cursor-pointer"
              onClick={() => {
                const payload = {
                  id_reference: rowData.id,
                  content: rowData.content,
                  summary: rowData.technical_sheet
                    ? {
                        ...rowData.technical_sheet,
                        products: rowData.technical_sheet.products?.map(
                          (entry) =>
                            typeof entry === "object"
                              ? {
                                  system: entry.title,
                                  system_products: entry.items,
                                }
                              : { single_product: entry }
                        ),
                      }
                    : null,
                  images: rowData.images_urls ?? [],
                  last_download: rowData.last_download,
                  edited_at: rowData.edited_at,
                  isClosed: true,
                };
                countryApiRequest
                  .post("/reference", payload, { responseType: "blob" })
                  .then((response) => {
                    let url = URL.createObjectURL(response);
                    let link = document.createElement("a");
                    link.href = url;
                    link.download = `${rowData.content.title}_${moment().format(
                      "YYYYMMDDhhmmss"
                    )}.pdf`;
                    link.click();
                    if (rowData.isNew || rowData.hasNotification)
                      onAction(rowData.id, rowData.cod_worksite_id);
                  })
                  .catch((e) => {
                    console.error(e);
                    push({
                      type: "error",
                      title: intl.formatMessage({ id: "an_error_occurred" }),
                    });
                  });
              }}
            />
          )}
        </div>
      </>
    ),
  },
  {
    title: intl.formatMessage({ id: "worksite" }),
    field: "address",
    headerStyle: { minWidth: 200 },
    cellStyle: { minWidth: 200, textTransform: "uppercase" },
    render: ({ address, isNew, hasNotification, status, worksiteStatus }) => {
      const badgeText = worksiteStatus
        ? `${intl.formatMessage({ id: "reference_report" })} (${intl
            .formatMessage({ id: worksiteStatus })
            .toLowerCase()})`
        : null;
      const badgeType =
        worksiteStatus === "open"
          ? "warning"
          : worksiteStatus === "closed"
          ? "success"
          : "error";

      return (
        <div className="flex items-center gap-2">
          {hasNotification && <NotificationPing />}
          <div>
            <span className="mr-1">{address}</span>
            {status === "reported_f" && (
              <Badge
                text={badgeText}
                type={badgeType}
                classNames="normal-case w-max-min whitespace-nowrap"
                textSize="text-xs"
              />
            )}
          </div>
          {isNew && (
            <span className="rounded-lg bg-red-500 text-white font-bold text-xs px-1.5 py-0.5">
              {intl.formatMessage({ id: "new_f" })}
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: intl.formatMessage({ id: "city" }),
    field: "city_prov",
    headerStyle: { minWidth: 200 },
    cellStyle: { minWidth: 200, textTransform: "uppercase" },
  },
  {
    title: intl.formatMessage({ id: "created_at" }),
    field: "created_at",
    render: ({ created_at }) => (
      <>{moment.utc(created_at).local().format("DD/MM/YYYY")}</>
    ),
  },
  {
    title: intl.formatMessage({ id: "title" }),
    field: "detail",
    headerStyle: { minWidth: 200 },
    cellStyle: {
      minWidth: 200,
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    render: ({ detail }) => detail ?? <>&mdash;</>,
  },
  {
    title: intl.formatMessage({ id: "state" }),
    field: "status",
    lookup: lkpStatus,
  },
];

export const OPTIONS = {
  filtering: true,
  toolbar: false,
  sorting: true,
  emptyRowsWhenPaging: false,
  pageSizeOptions: [5, 10, 20, 50],
  headerStyle: {
    fontWeight: "bold",
    fontSize: 15,
    paddingTop: 8,
    paddingBottom: 8,
  },
  filterCellStyle: { paddingTop: 8, maxWidth: 200 },
  cellStyle: { textTransform: "uppercase" },
  rowStyle: (x) => {
    if (x.class === "Totale") {
      return { fontWeight: "bold" };
    }
  },
};

export const LOCALIZATION = {
  header: {
    actions: "",
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} di {count} righe",
    labelRowsSelect: "Righe",
  },
};
